/*
 * ocWidgetHeader
 *
 * Designed to  allow us to have a common way to show and hide widgets
 */
import {AfterViewInit, Component, ElementRef, Input} from '@angular/core';
import {OX_KEYS} from '@ox/config';
import {Subscription} from 'rxjs';

@Component({
  selector: 'webu-oc-widget-header',
  templateUrl: './widget-header.component.html'
})
export class WidgetHeaderComponent implements AfterViewInit {
  @Input() collapseId: any;
  @Input() collapsible: any = false;

  public showPlus!: boolean;
  public isMobile!: boolean;
  eventName: string = OX_KEYS.EVENT.COLLAPSE_WIDGETS;
  public totalHeight: any;
  sub: Subscription;
  randNum: number = Math.round(Math.random() * (10000 - 1) + 1);
  private widgetPanel = '.gmWidgetPanel';
  private paymentHeader = 'onstar-paymentHeader-id-header cardTitle_';

  constructor(
    //private resizeListenerService: ResizeListenerService,
    private elRef: ElementRef
  ) {
  }

  ngAfterViewInit() {
    if (this.collapsible === 'true') {
      //this.isMobile = this.resizeListenerService.isMobile;
    }
    //this.sub = (this.resizeListenerService.mobile).subscribe(val => this.onMobileChange(val) );
  }

  public onMobileChange(newValue: any) {
    // newValue = newValue.getValue();
    if (this.collapsible === 'true') {
      if (newValue === true) {
        this.isMobile = true;
        this.collapse();
        document
          .querySelector('#cardTitle_' + this.randNum)
          ?.setAttribute('tabIndex', '0');
        if (
          document.getElementById(this.paymentHeader + this.randNum) != null
        ) {
          document
            .getElementById('' + this.paymentHeader + this.randNum)
            ?.setAttribute('tabindex', '0');
        }
      } else {
        this.isMobile = false;
        this.expand();
        document
          .querySelector('#cardTitle_' + this.randNum)
          ?.setAttribute('tabIndex', '-1');
        if (
          document.getElementById(this.paymentHeader + this.randNum) != null
        ) {
          document
            .getElementById(this.paymentHeader + this.randNum)
            ?.setAttribute('tabindex', '-1');
        }
      }
    }
  }

  public expandCollapse() {
    if (this.isMobile) {
      if (!this.showPlus) {
        this.collapse();
        return;
      }
      this.expand();
    }
  }

  // and that section will be opened.
  public expandWidgetHeader(id: any) {
    if (id === this.collapseId) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  // and then calls the expandCollapse() function to expand or collapse the card
  public processKeyEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') this.expandCollapse();
  }

  // Open Sections Remotely!!!
  // set this variable to be equal to the gmHeaderWidget collapsibleId attribute

  private collapse() {
    const target = this.elRef.nativeElement.parentNode.parentNode.querySelector(
      this.widgetPanel
    );
    this.totalHeight = target.offsetHeight;
    if (this.collapsible == 'true') {
      const props = [target.offsetHeight.toString() + 'px', '0px']; // from, to
      target.animate(
        {
          height: props,
          style: {
            visibility: 'visible'
          }
        },
        {
          duration: 1000,
          easing: 'ease-in-out',
          iterations: 1,
          fill: 'forwards'
        }
      );
      this.showPlus = true;
    }
  }

  // processKeyEvent checks to see if the user has pressed the enter key

  private expand() {
    if (this.isMobile === true) {
      this.showPlus = false;
      let target =
        this.elRef.nativeElement.firstElementChild.parentNode.parentNode.parentElement.querySelector(
          this.widgetPanel
        );
      if (target === null) {
        target = this.elRef.nativeElement.parentNode.parentNode.querySelector(
          this.widgetPanel
        );
      }
      const props = ['0px', target.scrollHeight.toString() + 'px'];
      target.style.visibility = 'visible';
      target.animate(
        {
          height: props
        },
        {
          duration: 1000,
          easing: 'ease-in-out',
          iterations: 1,
          fill: 'forwards'
        }
      );
    }
  }
}
